import React from 'react'
import { shallow, mount } from 'enzyme'

import Editor from '../../features/TextEditor/Editor'
import Files from '../../features/TextEditor/Files'

describe('Editor', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      topicName:'Test topic',
      published: true,
      predefined: false,
      isEditDraft: false,
      questionStatus: '',
      content: 'Some topic explanation',
      fileUUIDs: [],
      fileUrls: [],
      isBankUser: false,
      onPostClick: jest.fn(),
      onSaveAsDraftClick: jest.fn(),
      onCloseClick: jest.fn(),
      onDeleteClick: jest.fn(),
      onFileUpload: jest.fn(),
    },
    wrapper = shallow(<Editor {...props} />)
    instance = wrapper.instance()
  })
  it('should set default states', () => {
    expect(wrapper.state('isLinkModalOpen')).toBeFalsy()
    expect(wrapper.state('topicName')).toEqual(props.topicName)
    expect(wrapper.state('deleteFiles').length).toEqual(0)
    expect(wrapper.state('files').length).toEqual(0)
    expect(wrapper.state('buttonsDisabled')).toBeFalsy()
  })
  describe('#toggleLinkModal', () => {
    it('should toggle the isLinkModalOpen state everytime the method is called', () => {
      instance.toggleLinkModal()
      expect(wrapper.state('isLinkModalOpen')).toBeTruthy()
      instance.toggleLinkModal()
      expect(wrapper.state('isLinkModalOpen')).toBeFalsy()
    })
  })
  describe('#onChange', () => {
    it('should update the setState, saveMarkDown and changeButtonState methods', () => {
      const editorState = { content: 'some content'}
      const saveMarkDown = spyOn(instance, 'saveMarkdown')
      const changeButtonState = spyOn(instance, 'changeButtonState')
      instance.onChange(editorState)
      expect(wrapper.state('editorState')).toBe(editorState)
      expect(saveMarkDown).toHaveBeenCalledTimes(1)
      expect(changeButtonState).toHaveBeenCalledTimes(1)
    })
  })
  describe('#updateEditorState', () => {
    it('should set editorState to the content', () => {
      const editorState = { content: 'some content' }
      instance.updateEditorState(editorState)
      expect(wrapper.state('editorState')).toBe(editorState)
    })
  })
  describe('#changeButtonState', () => {
    it('should call checkButtonStatus function', () => {
      const editorState = { content: 'some content' }
      const checkButtonStatus = spyOn(instance, 'checkButtonStatus')
      instance.changeButtonState(editorState)
      expect(wrapper.state('buttonsDisabled')).toBeFalsy()
      expect(checkButtonStatus).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onEditorClick', () => {
    it('should call focus method', () => {
      const wrapper = mount(<Editor {...props}/>)
      const instance = wrapper.instance()
      const editor = spyOn(instance.editor, 'focus')
      instance.onEditorClick()
      expect(editor).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onFileUploadClick', () => {
    it('should call fileInput Click method', () => {
      wrapper = mount(<Editor {...props} />)
      instance = wrapper.instance()
      const fileInputClick = spyOn(instance.fileInput, 'click')
      instance.onFileUploadClick()
      expect(fileInputClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onTopicTitleChange', () => {
    it('should change the topicName state based on the value', () => {
      const event = { target: { value: 'topicName' } }
      instance.onTopicTitleChange(event)
      expect(wrapper.state('topicName')).toBe(event.target.value)
    })
  })
  describe('#onFileChange', () => {
    it('should update the file state and call checkbuttonStatus method', () => {
      const acceptedFiles = { dataTransfer : { files : { fileName: 'test.jpg'}} }
      const checkButtonStatus = spyOn(instance, 'checkButtonStatus')
      instance.onFileChange(acceptedFiles)
      expect(wrapper.state('files').length).toBe(1)
      expect(wrapper.state('buttonsDisabled')).toBeFalsy()
      expect(checkButtonStatus).toHaveBeenCalledTimes(1)
    })
  })
  describe('#getDeleteFilesUUID', () => {
    it('should return UUID of the selected filename ', () => {
      const fileUUID = {
        name: 'test.jpg',
        uuid: 'QWE123'
      }
      props.fileUUIDs.push(fileUUID)
      wrapper = shallow(<Editor {...props}/>)
      instance = wrapper.instance();
      const uuid = instance.getDeleteFilesUUID('test.jpg')
      expect(uuid[0]).toBe(fileUUID.uuid)
    })
  })
  describe('#onFileDeleteClick', () => {
    it('should return UUID of the selected filename ', () => {
      const fileUUID = {
        name: 'test.jpg',
        uuid: 'QWE123'
      }
      props.fileUrls.push(fileUUID)
      props.fileUUIDs.push(fileUUID)
      wrapper = shallow(<Editor {...props} />)
      instance = wrapper.instance();
      expect(wrapper.state('files').length).toBe(1)
      instance.onFileDeleteClick('test.jpg')
      expect(wrapper.state('files').length).toBe(0)
    })
  })
  describe('#getEditorContent', () => {
    it('should call saveMarkdown method', () => {
      const saveMarkdown = spyOn(instance, 'saveMarkdown')
      instance.getEditorContent()
      expect(saveMarkdown).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onPostClick', () => {
    it('should call props onPostClick method', () => {
      instance.onPostClick()
      expect(props.onPostClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onSaveAsDraftClick', () => {
    it('should call props onSaveAsDraftClick method', () => {
      instance.onSaveAsDraftClick()
      expect(props.onSaveAsDraftClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onCloseClick', () => {
    it('should call props onCloseClick method', () => {
      instance.onCloseClick()
      expect(props.onCloseClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#render', () => {
    it('should have the files props set to false by default', () => {
      const files = wrapper.find(Files).at(0)
      expect(files.props().published).toBeFalsy();
    })
  })
})